export default {
  SET_INVENTORIES: (state, data) => {
    state.inventories = data;
  },
  SET_INVENTORY: (state, data) => {
    state.inventory = data;
  },
};
